angular.module('leanlaw').factory('utils', [function () {
  /**
   * Standard email validation regex pattern
   * This pattern supports:
   * - Single character before @ symbol
   * - Dash characters in the local part
   * - Case insensitive letters     * - Multiple comma-separated emails (with optional space after comma)
   * Use this for consistent email validation across the application.
   * 
   * This service is only necessary for validating angular email inputs;
   * Remove when vue is fully implemented.
   */
  const emailRegexPattern = /^([a-zA-Z0-9][a-zA-Z0-9_.+\-!#$%&'*\/=?^`{|}~]*@([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,})(, ?[a-zA-Z0-9][a-zA-Z0-9_.+\-!#$%&'*\/=?^`{|}~]*@([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,})*$/;

  /**
   * Regex pattern for validating a single email address (no comma-separated values)
   * Used specifically for From email addresses in email delivery
   */
  const singleEmailRegexPattern = /^[a-zA-Z0-9][a-zA-Z0-9_.+\-!#$%&'*\/=?^`{|}~]*@([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/;
  return {
    emailRegexPattern: emailRegexPattern,
    singleEmailRegexPattern: singleEmailRegexPattern,
    isValidEmail: function (email) {
      if (!email) return false;
      return emailRegexPattern.test(email);
    },
    isValidSingleEmail: function (email) {
      if (!email) return false;
      return singleEmailRegexPattern.test(email);
    }
  };
}]);